import apiClient from '../../../../core/Api';
import { TagType, TagRequestParams } from '../../../../data/types/tags.interface';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

class IdentityService {
  static create = async (reqParams: TagRequestParams): Promise<TagType> =>
    apiClient.post(`${API_BASE_URL}/tag/identities`, reqParams).then((response) => response.data);

  static get = async (): Promise<TagType[]> =>
    apiClient.get(`${API_BASE_URL}/tag/identities`).then((response) => {
      const { data } = response;
      return data.rows;
    });

  static deleteIdentities = async (ids: number[]): Promise<boolean> => {
    const response = await apiClient.delete(`${API_BASE_URL}/tag/identities/${ids}`);
    return response.status === 204;
  };
}

export default IdentityService;
